import { createSelector } from 'reselect';

import { getCompany } from './company.selectors';

export const selectCustomQuestionsSchema = createSelector(
  getCompany,
  ({ customQuestionsSchema }) => customQuestionsSchema,
);
